import { MOCK_USERS } from '../data/mockData';
import axios from "../axios"
import { BASE_URL } from '../Utils';

const LOGIN_URL = BASE_URL + "/login";
const LOGOUT_URL = BASE_URL + "/logout";
const CHANGE_PASSWORD = BASE_URL + "/change-password";
const FORGOT_PASSWORD = BASE_URL + "/send-reset-password-link";
const UPDATE_PASSWORD = BASE_URL + "/update-password";
const PROFILE_URL = BASE_URL + "/profile";

const REYAGO_FIELD_APP_CLIENT_ID = "408fdc5c-735b-470e-b571-e92437462086.apps.reyago.reya.net"
const TWO_FACTOR_AUTHENTICATION_URL = BASE_URL + "/verify";


/**
 * POST /api/auth/login { email, password }
 * → Returns: { token, user: { id, name, role, phone, smsNumber, facilities[], routeId } }
 * → Store token in sessionStorage (NOT localStorage)
 * → role determines which view loads: phleb | driver | admin
 */
export function login(data) {
  return axios({
    url: LOGIN_URL,
    method: "post",
    data,
    headers: { Client: REYAGO_FIELD_APP_CLIENT_ID },
  });
}

/**
 * GET /api/auth/me  (Authorization: Bearer <token>)
 * → Validate on every page load
 * → 401 → redirect to login
 * → Returns user profile incl. assigned facilities / route
 */
export async function getSession(token) {
  // MOCK — replace with real fetch
  const role = token?.replace('mock-token-', '') || 'phleb';
  return MOCK_USERS[role] || null;
}

/**
 * PUT /api/users/:id { email, phone, smsNumber }
 * TWILIO: smsNumber is the number Twilio sends pickup-ready alerts to.
 *         Store separately from phone — driver may have different SMS number.
 */
export async function updateUserProfile(userId, updates) {
  // MOCK — replace with real fetch
  return { ...updates };
}

/**
 * POST /api/auth/logout
 * → Invalidate token server-side
 * → Clear sessionStorage token client-side
 */
export async function logOut() {
  return axios({
    url: LOGOUT_URL,
    method: "get",
  });
}


export function getProfile() {
  return axios({
    "url": PROFILE_URL,
    "method": "get"
  })
}

export function getUserCordinate(userId,data) {
  return axios({
    "url": `${BASE_URL}/users/${userId}`,
    "method": "put",
    data
  })
}